import { joinNavItemGroups, NavItem, NavItemSeparator } from '@billy/design-system'
import { TFunction } from 'i18next'

import { QuoteActionType } from '@features/invoices/enums/quoteActionType'

export const getQuoteActionsMenuItems = (
  activeQuoteMenuActions: QuoteActionType[],
  t: TFunction,
): NavItem<QuoteActionType | NavItemSeparator>[] => {
  const menuItemGroups: NavItem<QuoteActionType>[][] = [
    [
      {
        children: t('quotes.view.edit_quote'),
        iconLeft: 'squarePen',
        id: QuoteActionType.Edit,
        value: QuoteActionType.Edit,
      },
    ],
    [
      {
        children: t('quotes.view.mark_as_sent'),
        iconLeft: 'paperPlane',
        id: QuoteActionType.MarkAsSent,
        value: QuoteActionType.MarkAsSent,
      },
      {
        children: t('quotes.view.mark_as_unsent'),
        iconLeft: 'paperPlane',
        id: QuoteActionType.MarkAsUnsent,
        value: QuoteActionType.MarkAsUnsent,
      },
      {
        children: t('quotes.view.duplicate_quote'),
        iconLeft: 'copy',
        id: QuoteActionType.Duplicate,
        value: QuoteActionType.Duplicate,
        variant: 'primary',
      },
    ],
    [
      {
        children: t('quotes.view.delete_quote'),
        iconLeft: 'trash',
        id: QuoteActionType.Delete,
        value: QuoteActionType.Delete,
        variant: 'danger',
      },
    ],
  ]

  return joinNavItemGroups(
    menuItemGroups.map((group) => group.filter((item) => activeQuoteMenuActions.includes(item.value))),
  )
}
